<span
  >{{ "alreadyHaveAccount" | i18n }}
  <a [routerLink]="loginRoute" bitLink>{{ "logIn" | i18n }}</a></span
>
